export default {
  /**
   * 打开数据库
   * @param {object} dbName 数据库的名字
   * @param {string} storeName 仓库名称
   * @param {string} version 数据库的版本
   * @return {object} 该函数会返回一个数据库实例
   */
  openDB(dbName, tableName, version = 1) {
    return new Promise((resolve, reject) => {
      var indexedDB = window.indexedDB;
      let db;
      const request = indexedDB.open(dbName, version);
      request.onsuccess = function (event) {
        db = event.target.result;
        resolve(db);
      };
      request.onerror = function (event) {
        console.log("数据库打开报错");
      };
      request.onupgradeneeded = function (event) {
        console.log("onupgradeneeded");
        db = event.target.result; // 数据库对象
        var objectStore;
        objectStore = db.createObjectStore(tableName, {
          keyPath: "key", // 这是主键
        });
        // 创建索引，在后面查询数据的时候可以根据索引查
        // objectStore.createIndex("key1", "name", { unique: false });
      };
    });
  },

  /**
   * 新增数据
   * @param {object} db 数据库实例
   * @param {string} storeName 仓库名称
   * @param {object} data 数据
   */
  addData(db, storeName, data) {
    var request = db
      .transaction([storeName], "readwrite") // 事务对象 指定表格名称和操作模式（"只读"或"读写"）
      .objectStore(storeName) // 仓库对象
      .add(data);

    request.onsuccess = function (event) {
      console.log("数据写入成功");
    };

    request.onerror = function (event) {
      console.log("数据写入失败");
    };
  },
  
  /**
   * 通过主键读取数据
   * @param {object} db 数据库实例
   * @param {string} storeName 仓库名称
   * @param {string} key 主键值
   */
  getDataByKey(db, storeName, key) {
    return new Promise((resolve, reject) => {
      var transaction = db.transaction([storeName]); // 事务
      var objectStore = transaction.objectStore(storeName); // 仓库对象
      var request = objectStore.get(key); // 通过主键获取数据

      request.onerror = function (event) {
        console.log("事务失败");
      };

      request.onsuccess = function (event) {
        resolve(request.result);
      };
    });
  },
  /**
   * 更新数据
   * @param {object} db 数据库实例
   * @param {string} storeName 仓库名称
   * @param {object} data 数据
   */
  updateDB(db, storeName, data) {
    var request = db
      .transaction([storeName], "readwrite") // 事务对象
      .objectStore(storeName) // 仓库对象
      .put(data);

    request.onsuccess = function () {
      console.log("数据更新成功");
    };

    request.onerror = function () {
      console.log("数据更新失败");
    };
  },
  /**
   * 通过主键删除数据
   * @param {object} db 数据库实例
   * @param {string} storeName 仓库名称
   * @param {object} id 主键值
   */
  deleteDB(db, storeName, id) {
    var request = db
      .transaction([storeName], "readwrite")
      .objectStore(storeName)
      .delete(id);

    request.onsuccess = function () {
      console.log("数据删除成功");
    };

    request.onerror = function () {
      console.log("数据删除失败");
    };
  },
  /**
   * 清空仓库所有数据
   * @param {object} db 数据库实例
   * @param {string} storeName 仓库名称
   */
  clearDB(db, storeName) {
    var request = db
      .transaction([storeName], "readwrite")
      .objectStore(storeName)
      .clear();

    request.onsuccess = function () {
      console.log("数据清除成功");
    };

    request.onerror = function () {
      console.log("数据清除失败");
    };
  },
  /**
   * 关闭数据库
   * @param {object} db 数据库实例
   */
  closeDB(db) {
    db.close();
    console.log("数据库已关闭");
  },
  /**
   * 删除数据库
   * @param {object} dbName 数据库名称
   */
  deleteDBAll(dbName) {
    console.log(dbName);
    let deleteRequest = window.indexedDB.deleteDatabase(dbName);
    deleteRequest.onerror = function (event) {
      console.log("删除失败");
    };
    deleteRequest.onsuccess = function (event) {
      console.log("删除成功");
    };
  },
};
